import { Injectable } from "@angular/core";
import { ServiceMessageBrokerFactory } from "shared/provider-webworker";

import { PlatformProfileLookupService } from "./PlatformProfileLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class PlatformProfilePrimaryLookupService extends PrimaryLookupService<
  string,
  CubiqTS.PlatformProfileImpl
> {
  constructor(
    protected base: PlatformProfileLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.PlatformProfileImpl, cubiqWorker, "PlatformProfileImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let PlatformProfileObservable = cubiqWorker.primeStaticData<CubiqTS.PlatformProfileImpl>(
          CubiqTS.PlatformProfileImpl.name,
        );

        PlatformProfileObservable.subscribe(
          (platformProfiles: CubiqTS.PlatformProfileImpl[]) => {
            this.base.prime(platformProfiles);
          },
          (error: Error) => {
            console.debug("PlatformProfile prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("PlatformProfilePrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );
  }

  getPlatformProfile(id: string): Promise<CubiqTS.PlatformProfileImpl> {
    return this._primed.get().then(() => this.base.getPlatformProfile(id));
  }

  getPlatformProfiles(): Promise<CubiqTS.PlatformProfileImpl[]> {
    return this._primed.get().then(() => this.base.getAll());
  }
}
